// 投票
export const GET_CANDIDATE_LIST = 'get_candidate_list';
export const GET_CANDIDATE = 'get_candidate';
export const VOTE = 'vote';
